import React from "react";

export default function TextInput({
  onChange,
  value,
  placeholder,
  label,
  name,
  isSecret,
  isRequired,
  isDisabled,
  error,
}) {
  return (
    <div>
      <fieldset className="text-input">
        <input
          type={isSecret ? "password" : "text"}
          className={`input ${value ? "active" : "inactive"}`}
          name={name}
          onChange={onChange}
          placeholder={placeholder ?? ""}
          value={value}
          readOnly={isDisabled ? true : false}
        />
        <label htmlFor={name}>
          {label} {isRequired && <span className="req">*</span>}
        </label>
      </fieldset>
      {error && <span className="error-message">{error}</span>}
    </div>
  );
}
